<div class="page" [ngClass]="{'activeCmpt' : !modoEstandar}">

  <div class="header">
    <div class="titleClock">
      <h1 class="text-nowrap">GESTIÓN DE CONDUCTORES</h1>

      <div class="reloj">{{horaActual}}</div>

      <div class="indic" [ngClass]="{'active' : indicadores}">
        <div class="ico d-flex d-md-none"><img src="assets/img/icoIndicadores.svg"></div>
        <div class="label d-none d-md-block">INDICADORES</div>
        <div class="switch" (click)="indicadores = !indicadores">
          <span></span>
        </div>
      </div>

      <div class="modo" (click)="modoEstandar = !modoEstandar" [ngClass]="{'activeCmpt' : !modoEstandar}">
        <div class="but">ESTANDAR</div>
        <div class="but">COMPACTO</div>
      </div>

    </div>

    <div class="terminal" [tooltip]="sucursalesSelectedNombresLargos">
      <p><strong>TERMINAL:</strong>{{sucursalesSelectedNombres}}</p>
      <button class="btn btnBlack" (click)="openModalCambiarSucursal()">CAMBIAR</button>
    </div>
  </div>

  <div class="indicadores" [ngClass]="{'sinInd' : !indicadores}">
    <div class="contBoxes">
      <div class="box" [ngClass]="{'active': kpiSelected?.codigo == kpi.codigo}" *ngFor="let kpi of listaKPis"
        [ngStyle]="{'background-color': kpi.colorFondo}" (click)="filtrarPorKPI(kpi)" [tooltip]="kpi.descripcion"
        placement="bottom" container="body">
        <span [ngStyle]="{'color': kpi.colorLetra}">{{ kpi.tituloPantalla }}</span>
        <h1 [ngStyle]="{'color': kpi.colorLetra}">{{ kpi.valor }}</h1>
      </div>
    </div>
  </div>

  <div class="boxWhite" [ngClass]="{'sinInd' : !indicadores}">
    <div class="headBox">
      <div class="filtros" style="align-items: center;">
        <div class="buscar itemForm">
          <input type="search" class="form-control" placeholder="Buscar Conductor..." [(ngModel)]="textoBusqueda"
            (ngModelChange)="onBusquedaChange($event)">
        </div>

        <div class="select itemForm d-lg-block d-none" [tooltip]="getEstadosSeleccionados()">
          <ng-select class="select select-width" placeholder="Estado" [(ngModel)]="estadoConductor"
            (change)="changeEstadoConductorFiltro()" [multiple]="true" appendTo="body" [closeOnSelect]="false">
            <ng-template ng-multi-label-tmp let-items="items">
              <span style="display:block; font-size: 13px; top: 7px;color: var(--black)" class="ng-placeholder"
                *ngIf="items.length > 1">{{items.length}} Seleccionados</span>
              <span style="display:block; font-size: 13px; top: 7px; color: var(--black)" class="ng-placeholder"
                *ngIf="items.length == 1">{{ESTADOS_GESTION_CONDUCTOR[items[0]]}}</span>
            </ng-template>

            <ng-option *ngFor="let key of objectKeys(ESTADOS_GESTION_CONDUCTOR)" [value]="key"
              [disabled]="cantidadEstadoConductor[key] === 0">
              {{ESTADOS_GESTION_CONDUCTOR[key]}} <!--({{cantidadEstadoConductor[key]}})-->
            </ng-option>
          </ng-select>
        </div>

        <div class="check itemForm ms-3 d-lg-block d-none" style="width: initial;">
          <label>
            <input type="checkbox" [(ngModel)]="mostrarSoloHH" (ngModelChange)="getListaConductores(true)" />
            <span>
              Con Hrs Extras
            </span>
          </label>
        </div>


        <div class="check itemForm ms-3 d-lg-block d-none" style="width: initial">
          <label>
            <input type="checkbox" [(ngModel)]="sucDistJornadaActual" (ngModelChange)="getListaConductores(true)" />
            <span>
              Suc. Dist. (J. Actual)
            </span>
          </label>
        </div>
      </div>

      <div class="d-flex mt-sm-0 mt-3 align-items-center gap-3">
        <div class="btnSync">
          <div class="ico" (click)="reload()" [tooltip]="'Recargar datos'">
            <img src="assets/img/icoRefresh.svg" alt="">
          </div>
          <ng-select class="selectNg" [items]="recargas" bindLabel="label" bindValue="value" [(ngModel)]="recarga"
            placeholder="RECARGAR CADA..." (change)="calcularTime()" (clear)="recarga = 0; calcularTime()">
          </ng-select>
          <div class="barra" *ngIf="recarga != 0">
            <progressbar [max]="recarga/1000" [value]="contador/1000" [animate]="true" [striped]="true">
            </progressbar>
          </div>
        </div>

        <button class="ms-auto btn btnFilter d-lg-none d-block" (click)="filtroColap = !filtroColap">
          <img src="assets/img/icoFiltro.svg">
        </button>
      </div>

    </div>

    <div class="tableResp">
      <table class="table">
        <thead>
          <tr>
            <th (click)="onSort('visibleId')" style="cursor: pointer;" [tooltip]="'ID del conductor'" placement="bottom"
              container="body">
              ID Conductor
              <span *ngIf="orderBy === 'visibleId'" [innerHTML]="orderAsc ? '&#9650;' : '&#9660;'"></span>
            </th>
            <th (click)="onSort('nombres')" style="cursor: pointer;" [tooltip]="'Nombre del conductor'"
              placement="bottom" container="body">
              NOMBRES
              <span *ngIf="orderBy === 'nombres'" [innerHTML]="orderAsc ? '&#9650;' : '&#9660;'"></span>
            </th>
            <th (click)="onSort('estado')" style="cursor: pointer;" [tooltip]="'Estado operativo'" placement="bottom"
              container="body">
              ESTADO OPERATIVO
              <span *ngIf="orderBy === 'estado'" [innerHTML]="orderAsc ? '&#9650;' : '&#9660;'"></span>
            </th>
            <th (click)="onSort('servicio')" style="cursor: pointer;" [tooltip]="'Servicio / Sentido'"
              placement="bottom" container="body">
              SERVICIO/SENTIDO
              <span *ngIf="orderBy === 'servicio'" [innerHTML]="orderAsc ? '&#9650;' : '&#9660;'"></span>
            </th>
            <th (click)="onSort('inicioJornada')" style="cursor: pointer;"
              [tooltip]="'Inicio de jornada planificado / real'" placement="bottom" container="body">
              INI J PLANI/REAL
              <span *ngIf="orderBy === 'inicioJornada'" [innerHTML]="orderAsc ? '&#9650;' : '&#9660;'"></span>
            </th>
            <th (click)="onSort('H.disp')" style="cursor: pointer;" [tooltip]="'Horas disponibles / Turno'"
              placement="bottom" container="body">
              H. DISP./TURNO
              <span *ngIf="orderBy === 'H.dispo'" [innerHTML]="orderAsc ? '&#9650;' : '&#9660;'"></span>
            </th>
            <th (click)="onSort('terminoJornada')" style="cursor: pointer;"
              [tooltip]="'Término de jornada planificado / real'" placement="bottom" container="body">
              TÉRMINO J PLANI/REAL
              <span *ngIf="orderBy === 'terminoJornada'" [innerHTML]="orderAsc ? '&#9650;' : '&#9660;'"></span>
            </th>
            <th (click)="onSort('horasExtras')" style="cursor: pointer;"
              [tooltip]="'Horas extras autorizadas / realizadas'" placement="bottom" container="body">
              H. EXTRAS
              <span *ngIf="orderBy === 'horasExtras'" [innerHTML]="orderAsc ? '&#9650;' : '&#9660;'"></span>
            </th>
            <th (click)="onSort('minutosHhExtraPlanificados')" style="cursor: pointer;"
              [tooltip]="'Horas extras preautorizadas'" placement="bottom" container="body">
              H. EXTRAS PREAUTORIZADAS
              <span *ngIf="orderBy === 'horasExtras'" [innerHTML]="orderAsc ? '&#9650;' : '&#9660;'"></span>
            </th>
            <th (click)="onSort('terminalDePresentacion')" style="cursor: pointer;"
              [tooltip]="'Terminal de presentación'" placement="bottom" container="body">
              TERM. PRES.
              <span *ngIf="orderBy === 'terminalDePresentacion'" [innerHTML]="orderAsc ? '&#9650;' : '&#9660;'"></span>
            </th>
            <th (click)="onSort('terminalActual')" style="cursor: pointer;" [tooltip]="'Terminal actual'"
              placement="bottom" container="body">
              TERM. ACTUAL
              <span *ngIf="orderBy === 'terminalActual'" [innerHTML]="orderAsc ? '&#9650;' : '&#9660;'"></span>
            </th>
            <th (click)="onSort('contrato')" style="cursor: pointer;" [tooltip]="'Contrato'" placement="bottom"
              container="body">
              CONTRATO
              <span *ngIf="orderBy === 'contrato'" [innerHTML]="orderAsc ? '&#9650;' : '&#9660;'"></span>
            </th>
            <!-- <th (click)="onSort('tiempoOperativo')" style="cursor: pointer;">
              TIEMPO OPERATIVO
              <span *ngIf="orderBy === 'tiempoOperativo'" [innerHTML]="orderAsc ? '&#9650;' : '&#9660;'"></span>
            </th> -->
            <th (click)="onSort('horaColacion')" style="cursor: pointer;" [tooltip]="'Hora de colación'"
              placement="bottom" container="body">
              H. DE COLACIÓN
              <span *ngIf="orderBy === 'horaColacion'" [innerHTML]="orderAsc ? '&#9650;' : '&#9660;'"></span>
            </th>
            <th [tooltip]="'Acciones del conductor'" placement="bottom" container="body">ACCIÓN</th>
          </tr>
        </thead>


        <tbody>
          <tr *ngFor="let conductor of listaConductores" [ngClass]="{'alerta-tr': isConductorhoraExtraSobreHoraPlanificada(conductor),
          'alerta-tr-2': !isConductorhoraExtraSobreHoraPlanificada(conductor) && cercanoATerminarJornada(conductor)}">
            <td>{{conductor.visibleId}}</td>
            <td>{{conductor.nombres}} {{conductor.apellidoPaterno}}</td>
            <td>{{conductor.estado}} ({{tiemposOperativos[conductor.uuid]}})</td>
            <td>{{conductor.viajeEnCursoServicioSentido || '--'}}</td>
            <td>{{formatHoraInicioPlanificado(conductor.jornadaEnCurso)}} /
              {{formatHoraInicioReal(conductor.jornadaEnCurso)}}</td>
            <td>{{tiempoDisponible(conductor.jornadaEnCurso)}}/{{formatoTipoContrato(conductor.tipoContrato)}}</td>
            <td>{{formatHoraFinPlanificado(conductor.jornadaEnCurso)}} / {{formatHoraFinReal(conductor.jornadaEnCurso)}}
            </td>
            <td>
              {{getPrettyHorasExtras(conductor.hhExtraAutorizadas)}} /
              {{formatoHorasExtras(conductor.jornadaEnCurso.horasExtra)}}
            </td>
            <td>
              {{convertirMinutosEnHoras(conductor.minutosHhExtraPlanificados)}}
            </td>
            <td>{{conductor?.jornadaEnCurso?.sucursal.nombreAbreviado}}</td>
            <td>{{conductor?.sucursalActual?.nombreAbreviado}}</td>
            <td>{{conductor?.contratoCodigo}}</td>
            <!-- <td>{{muestraTiempoOperativo(conductor?.estadoFechaInicio)}}</td> -->
            <td>{{horaColacion(conductor.jornadaEnCurso)}}</td>
            <td>
              <div class="btns">
                <span *ngIf="tienePermisoCambiarEstadoCB()" [tooltip]="'Cambiar estado'">
                  <button class="btn btnEstado" (click)="cambiarEstadoCB(conductor)"><img
                      src="assets/img/icoCambioEstado.svg" alt=""></button>
                </span>
                <span *ngIf="tienePermisoCambiarSucursal()" [tooltip]="'Cambiar terminal'">
                  <button class="btn btnTerminal" (click)="cambiarSucursal(conductor)"><img
                      src="assets/img/icoTerminal.svg" alt=""></button>
                </span>
                <span *ngIf="tienePermisoFinalizarJornada()" [tooltip]="'Cerrar jornada'">
                  <button class="btn btnTerminar" (click)="cierreJornada(conductor)">
                    <img src="assets/img/icoTerminar.svg" alt=""></button>
                </span>
                <span *ngIf="tienePermisoImprimirVoucher()" [tooltip]="'Imprimir planilla'">
                  <button class="btn btnImprimir" (click)="modalImprimirVoucher(conductor)"
                    [disabled]="procesandoPdf"><img src="assets/img/icoPrint.svg" alt=""></button>
                </span>
                <span *ngIf="conductor.estado === 'FUERA_JORNADA' && tienePermisoDeshacerFinJornada()" [tooltip]="'Deshacer fin de jornada'">
                  <button class="btn btnDeshacer"><img src="assets/img/icoDeshacer.svg" alt=""
                      (click)="deshacerFinJornada(conductor)"></button>
                </span>
              </div>
            </td>
          </tr>

        </tbody>

      </table>
    </div>
  </div>
</div>

<div class="sideFiltros d-lg-none d-block" [ngClass]="{'colap' : !filtroColap}">

  <button class="btn btnClose" (click)="filtroColap = !filtroColap">
    <img src="assets/img/icoClose.svg" alt="">
  </button>
  <div class="title">Filtrar por:</div>

  <div class="select itemForm" [tooltip]="getEstadosSeleccionados()">
    <ng-select class="select select-width" placeholder="Estado" [(ngModel)]="estadoConductor"
      (change)="changeEstadoConductorFiltro()" [multiple]="true" appendTo="body" [closeOnSelect]="false">
      <ng-template ng-multi-label-tmp let-items="items">
        <span style="display:block; font-size: 13px; top: 7px;color: var(--black)" class="ng-placeholder"
          *ngIf="items.length > 1">{{items.length}} Seleccionados</span>
        <span style="display:block; font-size: 13px; top: 7px; color: var(--black)" class="ng-placeholder"
          *ngIf="items.length == 1">{{ESTADOS_GESTION_CONDUCTOR[items[0]]}}</span>
      </ng-template>

      <ng-option *ngFor="let key of objectKeys(ESTADOS_GESTION_CONDUCTOR)" [value]="key"
        [disabled]="cantidadEstadoConductor[key] === 0">
        {{ESTADOS_GESTION_CONDUCTOR[key]}} <!--({{cantidadEstadoConductor[key]}})-->
      </ng-option>
    </ng-select>
  </div>

  <div class="check itemForm" style="width: initial;">
    <label>
      <input type="checkbox" [(ngModel)]="mostrarSoloHH" (ngModelChange)="getListaConductores(true)" />
      <span>
        Con Hrs Extras
      </span>
    </label>
  </div>

  <div class="check itemForm" style="width: initial">
    <label>
      <input type="checkbox" [(ngModel)]="sucDistJornadaActual" (ngModelChange)="getListaConductores(true)" />
      <span>
        Suc. Dist. (J. Actual)
      </span>
    </label>
  </div>


  <div class="buttons">
    <button class="btnBlack" (click)="filtroColap = !filtroColap">APLICAR FILTRO</button>
    <button class="btn btnClean">LIMPIAR FILTRO</button>
  </div>
</div>